let addEditProspect = {
  fname: {
    conditions: {
      required: true,
      maxLength: 20,
    },
    message: "Maximum 20 character Allowed.!",
    valid: true,
    changed: false,
  },
  lname: {
    conditions: {
      required: true,
      maxLength: 20,
    },
    message: "Maximum 20 character Allowed.!",
    valid: true,
    changed: false,
  },
  comment: {
    conditions: {
      required: true,
      maxWordLength: 500,
      delimiter: " ",
    },
    message: "Maximum 500 Words Allowed.!",
    valid: true,
    changed: false,
  },
  reason_notinterest: {
    conditions: {
      required: true,
      maxWordLength: 100,
      delimiter: " ",
    },
    message: "Maximum 100 Words Allowed.!",
    valid: true,
    changed: false,
  },
  family_background: {
    conditions: {
      required: true,
      maxWordLength: 100,
      delimiter: " ",
    },
    message: "Maximum 100 Words Allowed.!",
    valid: true,
    changed: false,
  },
  goal: {
    conditions: {
      required: true,
      maxWordLength: 100,
      delimiter: " ",
    },
    message: "Maximum 100 Words Allowed.!",
    valid: true,
    changed: false,
  },
  inv_exp: {
    conditions: {
      required: true,
      maxWordLength: 100,
      delimiter: " ",
    },
    message: "Maximum 100 Words Allowed.!",
    valid: true,
    changed: false,
  },
  broker_quantum: {
    conditions: {
      required: true,
      maxWordLength: 100,
      delimiter: " ",
    },
    message: "Maximum 100 Words Allowed.!",
    valid: true,
    changed: false,
  },
  advisor_quantum: {
    conditions: {
      required: true,
      maxWordLength: 100,
      delimiter: " ",
    },
    message: "Maximum 100 Words Allowed.!",
    valid: true,
    changed: false,
  },
};

let prospectvalidations = Object.assign({}, addEditProspect);
module.exports = {
  addEditProspect: addEditProspect,
};
